import { useTranslation } from 'react-i18next'
import {
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from '@mui/material'
import { StateSchema } from '@/hooks/form/models'

import { RolloverAmountCalculationEnum } from '@/enums'

type Props = {
  handleOnChange: (name: string, value: any) => void
  state: StateSchema
}

const RolloverCalculationComponent = ({ handleOnChange, state }: Props) => {
  const { t } = useTranslation()

  const rolloverCalculation = [
    RolloverAmountCalculationEnum.lowerAmount,
    RolloverAmountCalculationEnum.riskAmount,
  ]

  return (
    <Box my={2} maxWidth={400}>
      <Typography fontWeight={700}>{t('rolloverCalculationType')}</Typography>
      <FormControl margin="normal" sx={{ my: '8px' }}>
        <RadioGroup
          name="rolloverAmountCalculationType"
          value={state.rolloverAmountCalculationType.value}
          onChange={(_, newValue: any | null) => {
            handleOnChange('rolloverAmountCalculationType', newValue)
          }}
        >
          {rolloverCalculation.map((calculation) => {
            return (
              <Box key={calculation}>
                <FormControlLabel
                  value={calculation}
                  control={<Radio color="primary" />}
                  label={`${t(`rolloverAmountCalculationType.${calculation}`)}`}
                />
              </Box>
            )
          })}
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

export default RolloverCalculationComponent
